const inr = (n) => `Rs. ${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export function waNumber(phone) {
  const digits = (phone || "").replace(/\D/g, "");
  if (!digits) return null;
  if (digits.length === 12 && digits.startsWith("91")) return digits;
  return `91${digits.slice(-10)}`;
}

export function openWhatsApp(phone, message) {
  const num = waNumber(phone);
  if (!num) return false;
  window.open(`https://wa.me/${num}?text=${encodeURIComponent(message)}`, "_blank");
  return true;
}

export function deliveryShareMessage(d) {
  const lines = [
    `Hello ${d.customer_name},`,
    ``,
    `Delivery update from SARAVANA DELAPP (${d.date ? new Date(d.date).toLocaleDateString("en-IN") : ""}):`,
    ``,
    `Bills:`,
    ...(d.bills || []).map((b) => `- ${b.invoice_number}: ${inr(b.amount)}`),
    ``,
    `Total: ${inr(d.total_amount)}`,
  ];
  if ((d.return_value || 0) > 0) lines.push(`Less returns: - ${inr(d.return_value)}`);
  lines.push(`Paid: ${inr(d.paid_amount)}`);
  lines.push(`Balance Due: ${inr(d.outstanding)}`);
  const returns = d.returns || [];
  if (returns.length) {
    lines.push(``);
    lines.push(`Return notes:`);
    returns.forEach((r) => lines.push(`- ${r.reason}${r.description ? ` (${r.description})` : ""}: ${inr(r.value)}`));
  }
  lines.push(``);
  lines.push(`Thank you!`);
  return lines.join("\n");
}

export function pendingBillsMessage(customer, pending) {
  const lines = [
    `Hello ${customer.name},`,
    ``,
    `Your pending bills with SARAVANA DELAPP:`,
    ``,
  ];
  pending.forEach((d) => {
    const inv = (d.bills || []).map((b) => b.invoice_number).join(", ");
    lines.push(`- ${inv}: ${inr(d.total_amount)} (Due: ${inr(d.outstanding)})`);
  });
  const total = pending.reduce((s, d) => s + (d.outstanding || 0), 0);
  lines.push(``);
  lines.push(`Total Outstanding: ${inr(total)}`);
  lines.push(``);
  lines.push(`Please arrange payment at the earliest. Thank you!`);
  return lines.join("\n");
}
